"use strict";
/**
 *  emphasisSentimentModule
 *
 * Description 策划中心 信息监控 实时线索 重点舆情
 * author: Qian.qianchen 2019-01-17
 */
angular.module('customDetailModule', [])
    .controller('customDetailController', ["$scope", "modalDialog", "trsHttpService", "$q", "$state",
        function($scope, modalDialog, trsHttpService, $q, $state) {
            initStatus();
            initData();
            /**
             * [initStatus description]状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    selectedNav: '',
                    page: {
                        PAGESIZE: 20,
                        CURRPAGE: 0,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 0
                    },
                    copyCurrPage: 0,
                }
                $scope.data = {
                    tabData: [],
                    arrData: []
                }
            }
            /**
             * [initData description]数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                getTabData().then(function() {
                    requestData();
                });
            }
            /**
             * [getTabData description] 获取tab数组数据
             * @return {[type]} [description]
             */
            function getTabData() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'customtitles',
                    'serviceid': 'customsentiment'
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.tabData = data;
                        $scope.status.selectedNav = angular.isDefined($state.params.navid) ? $state.params.navid : $scope.data.tabData[0].id;
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /**
             * [requestData description] 数据请求
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'customsentiments',
                    'serviceid': 'customsentiment',
                    'page_no': $scope.status.page.CURRPAGE,
                    'page_size': $scope.status.page.PAGESIZE,
                    'id': $scope.status.selectedNav
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.arrData = data.PAGEITEMS;
                        $scope.status.page.CURRPAGE = data.PAGEINDEX + 1;
                        $scope.status.page.PAGESIZE = data.PAGESIZE;
                        $scope.status.page.ITEMCOUNT = data.TOTALITEMCOUNT;
                        $scope.status.page.PAGECOUNT = data.PAGETOTAL;
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /*跳转指定页面*/
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.status.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.status.page.PAGECOUNT;
                }
                $scope.status.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };
            /**
             * [pageChange description] 分页点击触发方法
             * @return {[type]} [description]
             */
            $scope.pageChange = function() {
                $scope.status.page.CURRPAGE--;
                requestData();
            }
        }
    ]);